import { lazy } from 'react';

export const CreateOfferingPageLazy = lazy(() => import('./create-offering'));
